export const isInt = (n) => parseInt(n) === n;
export const isFloat = (n) => {
  return typeof n === "number" && !isInt(n);
};

/**
 * Возвращает правильный падеж для числительного
 * @param {string[]} titles - массив строк [ключ, ключа, ключей] lenght = 3
 * @param {number} num - число
 * @return string
 */
export const numCases = (titles, num) => {
  // если число - не целое то вернем сразу 2 ключ, так как
  // дробное число родительный падеж (-десятых, -сотых, -тысячных).
  if (isFloat(num)) return titles[1];

  // Эта часть просто спизжена от куда-то =)
  const cases = [2, 0, 1, 1, 1, 2];
  const val = Math.abs(num);
  const current =
    val % 100 > 4 && val % 100 < 20 ? 2 : cases[val % 10 < 5 ? val % 10 : 5];
  return titles[current];
};

/**
 * Copies to Clipboard value
 * @param {String} valueForClipboard value to be copied
 * @param {Boolean} isIOS is current browser is Ios (Mobile Safari)
 * @return {boolean} shows if copy has been successful
 */
export const copyToClipboard = (valueForClipboard) => {
  const isIOS = navigator.userAgent.match(/ipad|ipod|iphone/i);
  const textArea = document.createElement("textarea");
  textArea.value = valueForClipboard;

  textArea.style.position = "absolute";
  textArea.style.left = "-9999px"; // to make it invisible and out of the reach
  textArea.setAttribute("readonly", ""); // without it, the native keyboard will pop up (so we show it is only for reading)

  document.body.appendChild(textArea);

  if (isIOS) {
    const range = document.createRange();
    range.selectNodeContents(textArea);

    const selection = window.getSelection();
    selection.removeAllRanges(); // remove previously selected ranges
    selection.addRange(range);
    textArea.setSelectionRange(0, valueForClipboard.length); // this line makes the selection in iOS
  } else {
    textArea.select(); // this line is for all other browsers except ios
  }

  try {
    return document.execCommand("copy"); // if copy is successful, function returns true
  } catch (e) {
    return false; // return false to show that copy unsuccessful
  } finally {
    document.body.removeChild(textArea); // delete textarea from DOM
  }
};

/**
 * Задержка в милисекундах
 * @param {number} ms - количество милисекунд
 * @returns {promise}
 */
export const delay = (ms = 100) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });
};

/**
 * Get Cookie
 * @param {string} name
 * @returns {string} cookie value
 */
export function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

/* eslint-disable no-useless-escape */
export function setCookie(name, value, options = {}) {
  options = {
    path: "/",
    ...options,
  };

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie =
    encodeURIComponent(name) + "=" + encodeURIComponent(value);

  for (let optionKey in options) {
    updatedCookie += "; " + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }

  document.cookie = updatedCookie;
}

export const getCapsPercentage = (str) => {
  if (!str) return 0;
  const trimmed = str.trim();
  return trimmed.length
    ? Math.ceil(
        100 - (trimmed.replace(/[A-ZА-Я]/g, "").length / trimmed.length) * 100
      )
    : 0;
};
